/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BundleGroupsArrayResponseV3 } from '../../models/bundle-groups-array-response-v-3';
import { KeyType } from '../../models/key-type';
import { SortType } from '../../models/sort-type';

export interface GetBundleGroups$Params {
  organizationSiteKey: KeyType;

/**
 * Maximum number of items to return
 */
  limit?: number;

/**
 * Number of items to skip
 */
  offset?: number;

/**
 * Sort direction (asc or desc)
 */
  sort?: SortType;

/**
 * Field to sort bundle groups by
 */
  sortBy?: 'createdAt' | 'name' | 'status' | 'consignorKey' | 'carrierKey' | 'consigneeKey' | 'consignorName' | 'carrierName' | 'consigneeName';

/**
 * Field to filter bundle groups by
 */
  filterProperty?: 'name' | 'status' | 'consignorKey' | 'carrierKey' | 'consigneeKey' | 'consignorName' | 'carrierName' | 'consigneeName';

/**
 * Value to filter bundle groups by (partial match)
 */
  filterValue?: string;
}

export function getBundleGroups(http: HttpClient, rootUrl: string, params: GetBundleGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<BundleGroupsArrayResponseV3>> {
  const rb = new RequestBuilder(rootUrl, getBundleGroups.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sort', params.sort, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('filterProperty', params.filterProperty, {});
    rb.query('filterValue', params.filterValue, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BundleGroupsArrayResponseV3>;
    })
  );
}

getBundleGroups.PATH = '/organization-sites/{organizationSiteKey}/consignee/bundle-groups';
